import {
	PageBaseProps,
	BreadcrumbItemProps,
} from "../../components/Core/pageBase"
import { ContentAreaProperty } from "../../@types/CapioWeb/core"
import { StringProperty } from "../../@types/EpiFoundationSpa/Property"
import { Flex, Text, INNER_MAX_WIDTH } from "@capioweb/ui-components/src"
import React from "react"
import { EpiContext } from "../../context"
import { shouldRender } from "../../utils"
import { BlockResolver } from "../../components"
import { TermsAccordion } from "../../components/MyPages/TermsAccordion"
import { BlockCommonLayout } from "../../utils/layout"

interface MyPagesManageAccountPage extends PageBaseProps {
	heading: StringProperty
	ingress?: StringProperty
	breadcrumb: Array<BreadcrumbItemProps>
	mainContentArea: ContentAreaProperty
	termsOfServiceItem?: {
		header: string
		content: string
	}
}

const MyPagesManageAccountPage: React.FC<MyPagesManageAccountPage> = (
	props
) => {
	const { editMode } = React.useContext(EpiContext)

	return (
		<Flex display="block" w={1}>
			<Flex
				display="block"
				w={1}
				backgroundColor="greyEE"
				px={3}
				py={{ _: 5, m: 8, l: 13 }}
			>
				<Flex flexDirection="column" w={1} maxw={INNER_MAX_WIDTH} m="0 auto">
					<Text as="h1" variant="headline-1">
						{props.heading?.value}
					</Text>
					{props.ingress?.value && (
						<Text variant="preamble">{props.ingress?.value} </Text>
					)}
				</Flex>
			</Flex>
			{shouldRender(editMode.inEditMode, props.mainContentArea?.value) && (
				<div data-epi-edit="mainContentArea">
					<BlockResolver blocks={props.mainContentArea?.value} />
				</div>
			)}
			{props.termsOfServiceItem?.header && props.termsOfServiceItem?.content && (
				<BlockCommonLayout>
					<TermsAccordion
						title={props.termsOfServiceItem.header}
						body={props.termsOfServiceItem.content}
					/>
				</BlockCommonLayout>
			)}
		</Flex>
	)
}

export { MyPagesManageAccountPage }
